import React, { useEffect, useState } from 'react'

// Components
import { MESSAGES_CONST } from '../../../../const/messages-const'
import { MODAL_CONSTS } from '../../../../const/modal-const'

// Third party
import { AutorenewRounded } from '@mui/icons-material'

// Components
import DrawerComponent from '../../../../components/events/forms/review-publish/Components/DrawerComponent'

// Redux
import {
  resetScratchItems,
  setScratchViewVisibility,
} from '../../../../store/events/eventsSlice'
import { useAppDispatch } from '../../../../store/hooks'

// Services
import useToasterHelper from '../../../../helpers/ToasterHelper'

import { IEventInterface } from '../../../../models/events/event.interface'
import { IUserInterface } from '../../../../models/users/user.interface'

// Models
import { getUserFullName } from '../../../../helpers/helpers'
import { getFloatPrice } from '../../../../helpers/price'
import { getCurrency } from '../../../../helpers/payment'

import EventService from '../../../../services/firebase-service/event/EventService'

const UNKNOWN = 'Unknown'

const ButtonContainer: React.FC<{ children: any; className?: string }> = ({
  children,
  className,
}) => <div className={`w-full flex flex-col mt-2 mx-auto ${className}`}>{children}</div>

const ExhibitorScratchConfirmModal: React.FC<{
  show: boolean
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
  dataToPassOn: {
    user: IUserInterface
    eventId: string
    cardNo: string
    scratchTotal: number
    onSave?: () => Promise<void>
  }
}> = ({ show, handleModal, dataToPassOn }) => {
  // Hooks and vars
  const dispatch = useAppDispatch()
  const toastFunction = useToasterHelper()

  const [loading, setLoading] = useState(false)
  const [eventData, setEventData] = useState<IEventInterface | null>(null)

  const handleRemove = async () => {
    setLoading(true)

    try {
      if (dataToPassOn.onSave) await dataToPassOn.onSave()
      dispatch(setScratchViewVisibility(false))
    } catch (error) {
      console.error(error, 'error')
      toastFunction.error({
        message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    } finally {
      setLoading(false)
      dispatch(resetScratchItems())
      handleModal(false, MODAL_CONSTS.EXHIBITOR_SCRATCH_CONFIRM_MODAL)
    }
  }

  useEffect(() => {
    const getData = async () => {
      if (dataToPassOn.eventId) {
        const eventDataInDb = await EventService.get({ docId: dataToPassOn.eventId })
        setEventData(eventDataInDb.event)
      }
    }
    getData().then()
  }, [dataToPassOn.eventId])

  const currency = getCurrency(eventData?.currency)

  return (
    <DrawerComponent
      show={show}
      onHide={async () => {
        handleModal(false, MODAL_CONSTS.EXHIBITOR_SCRATCH_CONFIRM_MODAL)
        if (dataToPassOn.onSave) await dataToPassOn.onSave()
      }}
      title=""
      parentClasses="!mt-0"
      maxWidth={540}
    >
      <div className="px-2 text-SeabiscuitDark200ThemeColor">
        <div className="text-[24px] mb-3 top-5 left-6 absolute">Scratch successful</div>

        {/*This div just covers the x mark on the top right corner, it is just a work around because we need the users to click the "submit" button currently called closed*/}
        <div className="bg-[white] absolute top-1 right-1 w-10 h-10"></div>

        <div className="flex items-center mt-8 border border-[#122B461A] py-1 px-2 pl-1 rounded-lg text-base">
          <img
            className="w-10 h-10 mr-2 object-cover rounded-md"
            src={
              dataToPassOn.user?.userProfilePicture
                ? dataToPassOn.user?.userProfilePicture
                : 'assets/cp_icons/User-3.svg'
            }
            alt="exhibitorProfilePicutre"
          />
          <span className="font-normal">
            {dataToPassOn.user ? getUserFullName(dataToPassOn.user) : UNKNOWN}
          </span>
        </div>

        <div className="border border-[#122B461A] mt-2 rounded-lg text-nr p-3 overflow-auto">
          <div className="mb-3">Scratch Details:</div>
          <div className="w-full flex flex-col gap-3">
            <div className="flex items-start">
              <img
                src="/assets/cp_icons/UsDollarCircled1.svg"
                alt="dollarIcon"
                className="w-5 h-5 mx-2"
              />
              Amount scratched: {`${getFloatPrice(`${currency}${dataToPassOn?.scratchTotal}`)}`}
            </div>
            {dataToPassOn?.cardNo && (
              <div className="flex items-start">
                <img
                  src="/assets/cp_icons/MagneticCard-1.svg"
                  alt="dollarIcon"
                  className="w-5 h-5 mx-2"
                />
                Refund to: XXXX-XXXX-XXXX-{dataToPassOn?.cardNo}
              </div>
            )}
            <div className="flex items-start">
              <img src="/assets/cp_icons/Error-1.svg" alt="warningIcon" className="w-5 h-5 mx-2" />
              Refunds are not automatically processed. You must manually refund each item in the
              event finances tab in line with your refund policies.
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-8">
          <ButtonContainer className="mb-1.5">
            <button
              onClick={() => handleRemove()}
              className="items-center py-4 rounded-xl w-full relative bg-SeabiscuitMainThemeColor text-white disabled:opacity-[.5] border-1 border-transparent border-solid mt-0 text-nr text-center h-[53px] hover:bg-SeabiscuitMainThemeColor/90"
            >
              {loading ? <AutorenewRounded className="animate-spin" /> : 'Close'}
            </button>
          </ButtonContainer>
        </div>
      </div>
    </DrawerComponent>
  )
}
export default ExhibitorScratchConfirmModal
